import { useCallback } from 'react';

export const useStorageTimeStamp = () => {
  const COOKIE_NAME = 'analytics-session-timestamp';
  const COOKIE_DOMAIN = '.atlassian.com';
  const COOKIE_PATH = '/';
  const COOKIE_SECURE = 'true';
  const COOKIE_SAME_SITE = 'None';

  const setTimeStamp = useCallback(() => {
    try {
      const timestamp = Date.now();
      document.cookie = `${COOKIE_NAME}=${timestamp}; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; secure=${COOKIE_SECURE}; SameSite=${COOKIE_SAME_SITE}`;
    } catch (error) {
      console.warn('Failed to set session timestamp:', error);
    }
  }, []);

  const getTimeStamp = useCallback((): number | null => {
    try {
      const cookies = document.cookie.split(';');
      const cookie = cookies.find((c) =>
        c.trim().startsWith(`${COOKIE_NAME}=`),
      );
      const stored = cookie ? cookie.split('=')[1] : null;
      return stored ? parseFloat(stored) : null;
    } catch (error) {
      console.warn('Failed to get session timestamp:', error);
      return null;
    }
  }, []);

  const clearTimeStamp = useCallback(() => {
    try {
      document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    } catch (error) {
      console.warn('Failed to clear session timestamp:', error);
    }
  }, []);

  const calculateTimeDiff = useCallback((): number => {
    try {
      const timestamp = getTimeStamp();
      if (timestamp === null) {
        return -1;
      }

      const currentTime = Date.now();
      const timeDiff = currentTime - timestamp;

      // Clear the timestamp after calculating
      clearTimeStamp();

      return timeDiff;
    } catch (error) {
      console.warn('Failed to calculate time difference:', error);
      return -1;
    }
  }, [getTimeStamp, clearTimeStamp]);

  return {
    setTimeStamp,
    getTimeStamp,
    clearTimeStamp,
    calculateTimeDiff,
  };
};

export default useStorageTimeStamp;
